/** @file RadioButtons renders radio buttons that look coherent within the form lib. */
import * as constants from '@/components/Form/constants';
import { createChoiceComponent } from './factory';
/** @returns A typed single choice field component. */
export function createTypedRadioButtonsField() {
    return createChoiceComponent({
        name: constants.nameRadioButtons,
        /**
         * See `isEqual` in {@link module:factory.CreateChoiceComponentOptions}.
         *
         * @param currentValue Current value.
         * @param value Option value.
         * @returns True if the current value equals to option value.
         */
        isEqual(currentValue, value) {
            return currentValue === value;
        },
        /**
         * Render input element for a single option.
         *
         * @param data See {@link module:factory.RenderOptionInputData}.
         * @returns Input node.
         */
        renderOptionInput({ checked, descriptionId, emitInputEvent, name, optionData: { value, disabled }, ref, inputValueAttribute, }) {
            return (<input type="radio" aria-describedby={descriptionId} disabled={disabled} domProps={{ value, checked }} name={name} ref={ref} onInput={evt => {
                    if (evt.target.checked) {
                        emitInputEvent(value);
                    }
                }} value={inputValueAttribute}/>);
        },
    });
}
/** A pre-made component that is ready to accept string as values. */
export const RadioButtons = createTypedRadioButtonsField();
